import React, {useEffect, useMemo, useState} from 'react';
import Table from "../Table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";
import {useExchangeApi} from "../../api/ExchangeAPI";
import {useRowSelect, useTable} from "react-table";
import TableSkeleton from "../skeletons/TableSkeleton";
import DatePicker from "../DatePicker";
import {useSelector} from "react-redux";
import UtcToLocal from "../UtcToLocal";
import {formatCurrency} from "../../features/ValueFormater";

function ExchangeHistory() {
    const {getExchangeHistory, exchangeHistory, exchangeHistoryLoading, totalNbPage} = useExchangeApi();
    const {flag} = useSelector((state) => state.transferResponse);


    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [exchangeType, setExchangeType] = useState('All');

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            getExchangeHistory(exchangeType, startDateString, endDateString);
        }
    }, [exchangeType, dateRange]);

    useEffect(() => {
        if (dateRange && [0, 1].includes(flag)) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            setTimeout(() => {
                getExchangeHistory(exchangeType, startDateString, endDateString);
            }, 1000);
        }
    }, [flag]);


    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const formatUsd = (value) => {

        const amountNumber = Number(value.split(' ')[1]);
        const formattedAmount = amountNumber.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        const result = `${value.split(' ')[0]} ${formattedAmount}`;

        return result;
    }


    const data = useMemo(() => exchangeHistory || [], [exchangeHistory]);
    const columns = useMemo(
        () => [
            {
                Header: "Exchange",
                accessor: "Transaction",
            },
            {
                Header: "Date",
                accessor: "Date",
                Cell: ({cell: {value}}) => {
                    return <UtcToLocal utcTimestamp={value} options={options}/>
                },
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Type",
                accessor: "Type",
            },
            {
                Header: "Currency Amount",
                accessor: "ExchangeAmount",
                Cell: ({cell: {value}}) => {
                    return formatCurrency(value);
                },
            },
            {
                Header: "Exchange Rate",
                accessor: "ExchangeRate",
                Cell: ({cell: {value}}) => {
                    return formatCurrency(value);
                },
            },
            {
                Header: "Amount",
                accessor: "ExchangedAmount",
                Cell: ({cell: {value}}) => {
                    return formatCurrency(value);
                },
            }
        ],
        [exchangeHistory]
    );
    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} =
        useTable({columns, data}, useRowSelect,
        );
    const firstPageRows = rows.slice(0, 10);

    return (
        <div className="row ExchangeHistory">
            <div className="col-lg-10 col-sm-12">
                <div className="topTable">
                    <p>Exchange History</p>
                    <div>
                        <DatePicker
                            value={dateRange}
                            onChange={setDateRange}
                        />
                        <select
                            className="ddselect"
                            name="exchangeType"
                            id="account"
                            onChange={(e) =>
                                setExchangeType(e.target.value)
                            }
                        >
                            <option value="All">All Exchanges</option>
                            <option value="Buy">Buy Exchanges</option>
                            <option value="Sell">Sell Exchanges</option>
                        </select>
                    </div>
                </div>
                {
                    !exchangeHistoryLoading ? (
                        <Table
                            headerGroups={headerGroups}
                            page={rows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                            totalNbPage={totalNbPage}
                        />
                    ) : (
                        <TableSkeleton/>
                    )
                }

            </div>
            <div className="col-lg-2 col-sm-12"></div>
        </div>
    );
}

export default ExchangeHistory;